import { Box } from '@material-ui/core';

import { Font } from './Font';

interface ScoreCardProps {
  title: string | JSX.Element;
  subtitle: string | JSX.Element;
  value: string | number | JSX.Element;
  subValue?: string | number | JSX.Element;
}

export const ScoreCard = ({ title, subtitle, value, subValue }: ScoreCardProps) => {
  return (
    <Box display={'flex'} flexDirection={'column'} width={'100%'} justifyContent={'flex-start'}>
      <Font variant="h5" color={'title'} style={{ paddingBottom: '2px' }}>
        {title}
      </Font>
      <Font variant="overline" color={'textSecondary'} style={{ paddingBottom: '8px' }}>
        {subtitle}
      </Font>
      <Font variant="h2" color={'title'} style={{ paddingBottom: '4px' }}>
        {value}
      </Font>
      {subValue && (
        <Font variant="h5" color="textSecondary">
          {subValue}
        </Font>
      )}
    </Box>
  );
};
